import { Table, Input, Button, Modal, Checkbox } from "antd";
import React, { useEffect, useState } from "react";
import { httpGet, httpUrl, httpPost } from "../../api/httpClient";
import { deletedCode, loginTypeCode } from "../../lib/util/codeUtil"
import { CopyOutlined } from '@ant-design/icons';
import { reactLocalStorage } from "reactjs-localstorage";
import con from '../../const';
import QRCode from "react-qr-code";

const Search = Input.Search;

const AdminInfo = () => {
    const userInfo = reactLocalStorage.getObject(con.appName + "#loginInfo");
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
    });

    const [otpKeyModal, setOtpKeyModal] = useState(false);
    const [otpKey, setOtpKey] = useState("");
    const [otpKeyUrl, setOtpKeyUrl] = useState("")
    const [authCode, setAuthCode] = useState('');
    const [password, setPassword] = useState('');
    
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmNewPassword, setConfirmNewPassword] = useState('');
    
    useEffect(() => {
    }, [otpKeyModal]);

    const changePasswordDate = userInfo.passwordDate;
    const formattedDate = new Date(changePasswordDate);

    const year = formattedDate.getFullYear();
    const month = String(formattedDate.getMonth() + 1).padStart(2, '0');
    const day = String(formattedDate.getDate()).padStart(2, '0');
    const hours = String(formattedDate.getHours()).padStart(2, '0');
    const min = String(formattedDate.getMinutes()).padStart(2, '0');

    const formattedPWDate = `${year}년 - ${month}월 ${day}일 - ${hours}시 ${min}분`;


    // const getList = async () => {

    // };

    // const handleTableChange = (page) => {
    //     setPagination({
    //         ...pagination,
    //         current: page.current
    //     });
    // };

    const pwData = {
        password: currentPassword,
        newPassword: newPassword,
    };

    const handleChangePassword = () => {
        if (newPassword !== confirmNewPassword) {
            alert("새 비밀번호와 확인 비밀번호가 일치하지 않습니다.");
            return;
        }

        httpPost(httpUrl.changeAdminPW, [], pwData)
        .then(result => {
            if (result.data == "SUCCESS") {
                alert("비밀번호가 성공적으로 변경되었습니다.");
            } else {
                alert("비밀번호 변경에 실패하였습니다. 현재 비밀번호를 확인해주세요");
            }
        })
        .catch((e) => {
            console.log("Error:", e);
            alert("비밀번호 변경 중 오류가 발생하였습니다.");
        });
    };


    const settingOtp = () => {
        setOtpKeyModal(otpKeyModal => otpKeyModal = !otpKeyModal)
        if (userInfo.securityLevel < 1) getOtpKey();
    }

    const getOtpKey = () => {
        httpGet(httpUrl.getotpKey, [])
          .then(result => {
            result = result.data;
            console.log("## walletOtpGetKey: " + JSON.stringify(result));
            if (result.result){    
                setOtpKey(result.key);
                setOtpKeyUrl(result.url);
            }
          })
          .catch((e) => {
            console.log("## walletOtpGetKey error: " + e);
          });
    }

    const verifyOtp = () => {
        httpGet(httpUrl.setOtpVerify, [authCode])
        .then(result => {
            result = result.data;
            console.log("## walletOtpVerifyOtp: " + JSON.stringify(result));
            if (result){    
                const modifyUserInfo = userInfo;
                modifyUserInfo.securityLevel = 1;

                reactLocalStorage.setObject(con.appName + "#loginInfo", {...modifyUserInfo, securityLevel: 1});
                window.location.reload();
                setOtpKeyModal(false);
                alert("OTP가 등록완료 되었습니다.")
            } else {
                alert("인증번호가 다르거나 오류가 발생했습니다. 다시 시도해주세요.");                 
            }
        })
        .catch((e) => {
            console.log("## walletOtpGetKey error: " + e);
        });
    }

    const removeOtp = () => {
        httpPost(httpUrl.otpRemove, [password]).then((result)=>{
            console.log("## userPhoneauthCheck result: " + JSON.stringify(result));
            result = result.data;              
            if(result){        
                console.log(result)  
                const modify = userInfo;
                modify.securityLevel = 0;
                reactLocalStorage.setObject(con.appName + "#loginInfo", {...modify, securityLevel: 0})
                alert("OTP인증이 해제되었습니다. QR코드 스캔을 통해 새로운 OTP 등록을 진행해주세요.")
                setOtpKeyModal(false);
                getOtpKey();
          } else {
            alert("비밀번호가 맞지 않거나 오류가 발생했습니다. 다시 시도해주세요.");                  
        }
        }).catch(e=>{
          console.log ("## userPhoneauthCheck error: " + e)
        });    
    }
    return (
        <div id="admin" className="main">
             <div className="main-title">관리자 정보</div>
            <div className="container">
                <div className="background-container">
                    <div className="container">
                        <div className="title">
                            업체명
                        </div>
                        <div className="content">
                            {userInfo.companyName}
                        </div>
                    </div>

                    <div className="container">
                        <div className="title">
                            아이디
                        </div>
                        <div className="content">
                            {userInfo.id}
                        </div>
                    </div>

                    <div>
                        <div className="container">
                            <div className="title">
                                비밀번호 변경
                            </div>
                        </div>

                        <div className="container-sub">
                            <div className="sub-title">
                                현재 비밀번호
                            </div>
                            <Input
                                type="password"
                                placeholder="현재 비밀번호를 입력해주세요"
                                className="input"
                                value={currentPassword}
                                onChange={(e) => setCurrentPassword(e.target.value)}
                            />
                        </div>

                        <div className="container-sub">
                            <div className="sub-title">
                                새 비밀번호
                            </div>
                            <Input
                                type="password"
                                placeholder="새로운 비밀번호를 입력해주세요"
                                className="input"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                            />
                        </div>
                        
                        <div className="container-sub">
                            <div className="sub-title">
                                새 비밀번호 확인
                            </div>
                            <Input
                                type="password"
                                placeholder="새로운 비밀번호를 다시 입력해주세요"
                                className="input"
                                value={confirmNewPassword}
                                onChange={(e) => setConfirmNewPassword(e.target.value)}
                            />
                            <div className="container-sub">
                                <div className="memo">
                                    {(newPassword && confirmNewPassword )
                                    ?   (newPassword == confirmNewPassword)
                                            ? <div style={{ color: "rgb(56, 128, 164)" }}> 입력한 비밀번호가 일치합니다.</div>
                                            : '비밀번호가 일치하지 않습니다.'
                                    : "" }
                                </div>
                            </div>
                        </div>
                        <div className="container">
                            <div className="title">
                            </div>
                            <Button
                                className="btn"
                                onClick={handleChangePassword}
                            >
                                변경하기
                            </Button>
                        </div>
                    </div>

                    <div className="container">
                        <div className="title">
                            이메일
                        </div>
                        <div className="content">
                            {userInfo.email}
                        </div>
                    </div>

                    <div className="container">
                        <div className="title">
                            비밀번호 변경일시
                        </div>
                        <div className="content">
                            {formattedPWDate}
                        </div>
                    </div>

                    <div className="container">
                        <div className="title">
                            OTP 인증
                        </div>
                        {/* <Input
                            name="title"
                            placeholder="인증번호를 입력해주세요"
                            className="phone-input"
                            disabled={!otpKey}
                            // onChange={onChange}
                            // ref={formRef}
                        /> */}
                        <Button
                            className="btn"
                            style={{ }}
                            onClick={settingOtp}
                        >
                            {userInfo.securityLevel === 0 ? "인증하기" : "인증해제"}
                        </Button>
                    </div>
                </div>
                {otpKeyModal && 
                <div>
                    <div className="modal-overlay" onClick={()=>setOtpKeyModal(false)} />
                    <div className="modal-wrapper otp">
                        <div className="modal-header">
                            <div><span style={{ fontWeight: '600' }}></span> {userInfo.securityLevel === 0 ? "OTP KEY 등록" : "OTP 인증해제" }</div>
                            <Button onClick={()=>setOtpKeyModal(false)} style={{ border: 'none', boxShadow: 'none' }}>close</Button>
                        </div>
                        { userInfo.securityLevel === 0 ?
                            <div className='otpModalContainer'>                        
                                <div className=''>
                                    <QRCode                                    
                                        size={160}
                                        color='#000'
                                        value={otpKeyUrl}                                 
                                    />
                                    <p className='otykey'>{otpKey}<span><CopyOutlined onClick={()=>{onCopyCode();}}/></span></p>
                                </div>
                                <div className='formBox'>     
                                    <input onChange={(e)=>{setAuthCode(e.target.value)}} className="otpInput"/>        
                                </div>                  
                            </div>
                            :
                            <div className='otpModalContainer'>                       
                                <div className='formBox'>
                                    <p style={{textAlign:'center', marginBottom: 12}}>계정 비밀번호를 입력해주세요</p>
                                    <input type="password" onChange={(e)=>{setPassword(e.target.value)}} className="otpInput"/>        
                                </div>                  
                            </div>
                        }                      
                       
                        <button className="otpBtn" onClick={userInfo.securityLevel === 0 ? verifyOtp : removeOtp}>확인</button> 
                      
                    </div>
                </div>}
            </div>

        </div>
    );

}

export default AdminInfo;
